export default {
      id: "siteHover-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "icons.svg#siteHover",
      toString: function () {
        return this.url;
      }
    }